import { render } from "./ManageCustomFields.vue?vue&type=template&id=101d3d48"
import script from "./ManageCustomFields.vue?vue&type=script&lang=js"
export * from "./ManageCustomFields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__